import { isErrorFunction } from "./httpClient";
const fetchHttpPost = ({ apiUrl, getAuthToken, device, version }) => async ({ endpoint, body, signal, result }) => {
    const response = await fetch(`${apiUrl()}${endpoint}`, {
        method: "POST",
        headers: {
            ["Content-Type"]: "application/json",
            Authorization: getAuthToken ? `Bearer ${await getAuthToken()}` : "",
            Device: device,
            Version: version,
        },
        body: JSON.stringify(body),
        signal,
    });
    return await processResponse({ response, result });
};
const multipartFetchHttpPost = ({ apiUrl, getAuthToken, device, version }) => async ({ endpoint, body, signal, result }) => {
    const formData = new FormData();
    for (const name in body) {
        formData.append(name, body[name]);
    }
    const response = await fetch(`${apiUrl()}${endpoint}`, {
        method: "POST",
        headers: {
            Authorization: getAuthToken ? `Bearer ${await getAuthToken()}` : "",
            Device: device,
            Version: version,
        },
        body: formData,
        signal,
    });
    return await processResponse({ response, result });
};
const fetchHttpPut = ({ apiUrl, getAuthToken, device, version }) => async ({ endpoint, body, signal, result }) => {
    const response = await fetch(`${apiUrl()}${endpoint}`, {
        method: "PUT",
        headers: {
            ["Content-Type"]: "application/json",
            Authorization: getAuthToken ? `Bearer ${await getAuthToken()}` : "",
            Device: device,
            Version: version,
        },
        body: JSON.stringify(body),
        signal,
    });
    return await processResponse({ response, result });
};
const fetchHttpDelete = ({ apiUrl, getAuthToken, device, version }) => async ({ endpoint, body, signal, result }) => {
    const response = await fetch(`${apiUrl()}${endpoint}`, {
        method: "DELETE",
        headers: {
            ["Content-Type"]: "application/json",
            Authorization: getAuthToken ? `Bearer ${await getAuthToken()}` : "",
            Device: device,
            Version: version,
        },
        body: JSON.stringify(body),
        signal,
    });
    return await processResponse({ response, result });
};
const fetchHttpGet = ({ apiUrl, getAuthToken, device, version }) => async ({ endpoint, signal, result }) => {
    const response = await fetch(`${apiUrl()}${endpoint}`, {
        method: "GET",
        headers: {
            ["Content-Type"]: "application/json",
            Authorization: getAuthToken ? `Bearer ${await getAuthToken()}` : "",
            Device: device,
            Version: version,
        },
        referrer: "",
        signal,
    });
    return await processResponse({ response, result });
};
const processResponse = async ({ response, result }) => {
    if (response.ok) {
        const responseText = await response.text();
        const responseResult = responseText ? JSON.parse(responseText) : responseText;
        return result?.success ? result?.success(responseResult) : responseResult;
    }
    if (result?.error !== undefined) {
        return isErrorFunction(result.error) ? result.error(response) : result.error;
    }
    throw new Error(response.statusText);
};
export { fetchHttpDelete, fetchHttpGet, fetchHttpPost, fetchHttpPut, multipartFetchHttpPost };
